export class ArbetsorderPlaneringSchedulerSettingsTexts {
// eslint-disable-next-line sonarjs/public-static-readonly
    static texts = {
        zoom: "Välj zoomnivå",
        betraktelsedatum: "Navigera till",
        idag: "Idag",
        nastaManad: "Nästa månad",
        hanteraMaskinlag: "Hantera maskinlag",
        installningar: "Inställningar",
        minaMaskinlag: "Mina maskinlag"
    };
}
